module.exports = __webpack_public_path__ + "static/media/UPGCatalogBanner-lg.ff8bf96e.jpg";